// Drag-Guard: Behebt "verhakte" Zieh-Interaktionen (Resizer, Panels, Post-its).
//
// Problem 1: iframes (Email-Ansicht, PDF-Vorschau) schlucken mousemove/mouseup,
//   sobald der Zeiger darüber gerät → Drag friert ein, Loslassen wird nicht erkannt.
//   Lösung: Während des Ziehens bekommt <body> die Klasse 'drag-in-progress',
//   CSS setzt dann pointer-events:none auf alle iframes.
//
// Problem 2: Maustaste wird ausserhalb des Fensters losgelassen → mouseup geht
//   verloren, der Drag läuft weiter. Lösung: dragEnded(e) in jedem mousemove
//   prüfen — wenn keine Taste mehr gedrückt ist, Drag beenden.

let activeGuards = 0

/** Beim Drag-Start aufrufen. Gibt eine Funktion zurück, die beim Drag-Ende aufgerufen werden MUSS. */
export function startDragGuard() {
  activeGuards++
  document.body.classList.add('drag-in-progress')
  let released = false
  return () => {
    if (released) return
    released = true
    activeGuards = Math.max(0, activeGuards - 1)
    if (activeGuards === 0) document.body.classList.remove('drag-in-progress')
  }
}

/** In mousemove-Handlern: true, wenn keine Maustaste mehr gedrückt ist (mouseup verpasst). */
export function dragEnded(e) {
  return e.buttons === 0
}
